import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { checkboxClasses } from '@mui/material';
import { useFormik } from 'formik';
import { groomTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const GroomWearTTK = () => {
    const workingSinceOption = checkboxData.workSinceOption;
    const serviceOfferedGroomOption = checkboxData.serviceOfferedGroom;
    const storeTypeOption = checkboxData.storeTypeGroom
    const deliveryDateOption = checkboxData.deliveryDate

    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const formik = useFormik({
        initialValues: {
            workingSince: merchant?.workingSince || [],
            serviceOfferedGroom: merchant?.serviceOfferedGroom || [],
            storeTypeGroom: merchant?.storeTypeGroom || [],
            deliveryDate: merchant?.deliveryDate || [],
            startingPrice: Math.floor(merchant?.startingPrice * currency.value) || '',
            sherwaniPrice: Math.floor(merchant?.sherwaniPrice * currency.value) || ''
        },
        enableReinitialize: true,
        validationSchema: groomTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: {
                        ...values,
                        startingPrice: Math.floor(values.startingPrice * currency.country_value),
                        sherwaniPrice: Math.floor(values.sherwaniPrice * currency.country_value)
                    },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    const [ttkEditMode, setTtkEditMode] = useState(false)
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Starting Price</th>
                                                            <th style={{ width: '25%' }}>Services Offered</th>
                                                            <th style={{ width: '25%' }}>Store Type </th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>

                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.startingPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{
                                                                merchant.serviceOfferedGroom?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    )
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.storeTypeGroom?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    )
                                                                })
                                                            }</td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Delivery Date</th>
                                                            <th>Sherwani Price</th>
                                                        </tr>
                                                        <tr>

                                                            <td>{
                                                                merchant.deliveryDate
                                                                    ?.map((item, index) => {
                                                                        return <p key={index}>{item.value}</p>
                                                                    })
                                                            }</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.sherwaniPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                   <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Price</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="startingPrice"
                                                            placeholder='Starting Price'
                                                            value={formik.values.startingPrice}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.startingPrice && formik.errors.startingPrice ? (
                                                        <div className="text-danger">{formik.errors.startingPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Services Offered<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={serviceOfferedGroomOption}
                                                            selected
                                                            value={formik.values.serviceOfferedGroom}
                                                            onChange={(serviceOfferedGroom) => formik.setFieldValue('serviceOfferedGroom', serviceOfferedGroom)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.serviceOfferedGroom && formik.errors.serviceOfferedGroom ? (
                                                            <div className="text-danger">{formik.errors.serviceOfferedGroom}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Store Type<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={storeTypeOption}
                                                            selected
                                                            value={formik.values.storeTypeGroom}
                                                            onChange={(storeTypeGroom) => formik.setFieldValue('storeTypeGroom', storeTypeGroom)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.storeTypeGroom && formik.errors.storeTypeGroom ? (
                                                            <div className="text-danger">{formik.errors.storeTypeGroom}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Delivery Date<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={deliveryDateOption}
                                                            selected
                                                            value={formik.values.deliveryDate}
                                                            onChange={(deliveryDate) => formik.setFieldValue('deliveryDate', deliveryDate)}
                                                            onBlur={formik.handleBlur}

                                                        />
                                                        {formik.touched.deliveryDate && formik.errors.deliveryDate ? (
                                                            <div className="text-danger">{formik.errors.deliveryDate}</div>
                                                        ) : null}

                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Sherwani Price</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="sherwaniPrice"
                                                            placeholder='Sherwani Price'
                                                            value={formik.values.sherwaniPrice}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.sherwaniPrice && formik.errors.sherwaniPrice ? (
                                                        <div className="text-danger">{formik.errors.sherwaniPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='form-group text-center'>
                                                    <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }} >{ttkEditMode ? 'Save Changes' : 'Submit'}</button>
                                                </div>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default GroomWearTTK